var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIi4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7979 24.3954H11.183C10.2303 24.3954 9.45508 23.6202 9.45508 22.6675V13.3119C9.45508 12.3592 10.2303 11.584 11.183 11.584H24.7979C25.7506 11.584 26.5258 12.3592 26.5258 13.3119V22.6675C26.5258 23.6204 25.7506 24.3954 24.7979 24.3954ZM11.183 12.722C10.8577 12.722 10.5931 12.9868 10.5931 13.3119V22.6675C10.5931 22.9927 10.8577 23.2573 11.183 23.2573H24.7979C25.1232 23.2573 25.3878 22.9926 25.3878 22.6675V13.3119C25.3878 12.9866 25.123 12.722 24.7979 12.722H11.183Z",
    fill: "#160404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9905 19.9669C16.9647 19.9669 15.9801 19.5322 15.2891 18.7742L9.92798 12.8917L10.7692 12.125L16.1304 18.0074C16.6131 18.537 17.2737 18.8289 17.9905 18.8289C18.7073 18.8289 19.3679 18.5372 19.8508 18.0074L25.2122 12.125L26.0532 12.8917L20.6917 18.7741C20.0009 19.5322 19.0163 19.9669 17.9905 19.9669Z",
    fill: "#160404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1734 17.8427L9.95874 23.084L10.7655 23.8867L15.9802 18.6454L15.1734 17.8427Z",
    fill: "#160404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8083 17.8438L20.0015 18.6465L25.2161 23.8885L26.023 23.0858L20.8083 17.8438Z",
    fill: "#160404"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.28,
    height: 17.28,
    fill: "white",
    transform: "translate(9.36011 9.35938)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIi4);
export default __webpack_public_path__ + "static/media/ii4.da60b9740ca11f9fc61e14e73bbec4af.svg";
export { ForwardRef as ReactComponent };